export enum MyGamesRoutes {
  ROOT = ''
}
